import { Steps } from "./steps"

// Every value a step can send on this route needs a row: the state machine throws on an unmatched one.
//prettier-ignore
export default [
  { at: Steps.BEFORE_YOU_CONTINUE_WARNING,   given: "",                                             goto: Steps.RELATED_TO_PRIMARY_SERVICE },
  { at: Steps.RELATED_TO_PRIMARY_SERVICE,    given: "PRIMARY_SERVICE",                              goto: Steps.UPLOAD_STATEMENT },
  { at: Steps.RELATED_TO_PRIMARY_SERVICE,    given: "PRIMARY_SERVICE_CANNOT_BE_SUBMITTED",          goto: Steps.CANNOT_BE_SUBMITTED },
  { at: Steps.RELATED_TO_PRIMARY_SERVICE,    given: "ANOTHER_SERVICE",                              goto: Steps.SERVICE_NOT_SCHEDULED },
  { at: Steps.RELATED_TO_PRIMARY_SERVICE,    given: "NO",                                           goto: Steps.CANNOT_BE_SUBMITTED },
  { at: Steps.UPLOAD_STATEMENT,              given: "ABOUT_EXPENSE_ELIGIBLE_REIMBURSEMENT_AMOUNT", goto: Steps.ELIGIBLE_REIMBURSEMENT_AMOUNT },
  { at: Steps.ELIGIBLE_REIMBURSEMENT_AMOUNT, given: "",                                           goto: Steps.CBPD_PLACEHOLDER }
]
